import '.de{display:block;}.ssr-plugin'
import '.d2{margin-bottom:8px;}.ssr-plugin'
import '.gj{font-family:Neulis-Regular;}.ssr-plugin'
import '.ce{font-size:16px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.gk{padding:0px 12px;}.ssr-plugin'
import '.a0{height:44px;}.ssr-plugin'
import '.gl{max-height:44px;}.ssr-plugin'
import '.dk{min-height:44px;}.ssr-plugin'
import '.gm{background-color:transparent;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.di{outline:none;}.ssr-plugin'
import '.gn{transition:box-shadow 150ms ease, border-color 200ms ease;}.ssr-plugin'
import { ChangeEvent } from 'react'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type TextInputProps = {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void
  error?: boolean
  label?: string
  placeholder?: string
  id?: string
  style?: Style
}

export const TextInput = ({
  value,
  onChange,
  onBlur,
  error,
  style,
  id,
  label,
  placeholder,
}: TextInputProps) => {
  return (
    <styled.div style={style}>
      <label className="subtext de d2"
        style={{
          color: error ? colors.red : colors.white,
          opacity: error ? 1 : 0.5,
        }}
      >
        {label}
      </label>
      <styled.input className="gj ce m gk a0 gl dk gm cx di gn"
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={{
          color: colors.white,
          border: error
            ? `1px solid ${colors.red}`
            : `1px solid rgba(255,255,255,0.24)`,
          '&::placeholder': {
            color: `${transparentColor(colors.white, 0.5)}`,
            fontFamily: 'Neulis-Regular',
          },
          '&:focus': {
            border: `1px solid ${colors.white}`,
            boxShadow: `0 0 0 3px ${transparentColor(colors.white, 0.35)}`,
          },
        }}
      />
    </styled.div>
  )
}
